import { defineView } from "@/ReactSetup/view-definitions";

const definition = defineView({
    name: "ProductPage",
    component: () => (__SERVER__ ? require("./product-page-view") : import("./product-page-view"))
});

export default definition;
